import * as React from 'react'
import { FieldInputProps, FormikProps, FormikValues } from 'formik'

import RadioGroup from '../ui/radioGroup'

import { SelectOption } from '../../store/commonTypes'

import './form.sass'

interface Props {
    label: string
    field: FieldInputProps<string>
    form: FormikProps<FormikValues>
    options: SelectOption[]
}

const RadioGroupField: React.FunctionComponent<Props> = ({ form, field, label, options }: Props) => {
    return (
        <div className="form__fieldContainer">
            <RadioGroup {...field} form={form} label={label} field={field} options={options} />
        </div>
    )
}

export default RadioGroupField
